import {Modal} from 'antd';
import {useEffect, useState} from 'react';

import {Locale} from '../../../provider/locale/locale';
import {useCreateEvent} from '../../../service/events/events-hook';
import {CommonEventStatusEnum, EventFormType} from '../../../service/events/events-type';
import {postCompanySelectorCompanySchema} from '../../../service/feature-companies/feature-companies-api-type';
import {CompaniesSelectorFeatureEnum} from '../../../service/feature-companies/feature-companies-const';
import {useCompaniesSelector} from '../../../service/feature-companies/feature-companies-hook';
import {PostSelectorCompanyType} from '../../../service/feature-companies/feature-companies-type';

import {EventForm} from './event-form';
import {EVENT_SELECT_COMPANIES_STEP_WIDTH, prepareEventRequestData} from './event-form-helper';

type PropsType = {
    setIsOpen: (isOpen: boolean) => void;
    onCreateSuccess?: VoidFunction;
};

export function CreateEventFormModal({setIsOpen, onCreateSuccess}: PropsType): JSX.Element {
    const [modalWidth, setModalWidth] = useState<number>(EVENT_SELECT_COMPANIES_STEP_WIDTH);

    const companiesSelector = useCompaniesSelector<PostSelectorCompanyType>({
        feature: CompaniesSelectorFeatureEnum.Posts,
        companySchema: postCompanySelectorCompanySchema,
        resourceId: null,
    });

    const {mutateAsync: createEvent} = useCreateEvent();
    const {initializeSelector, selectorId} = companiesSelector;

    useEffect(() => {
        initializeSelector();
    }, [initializeSelector]);

    async function handleSubmit(values: EventFormType, status: CommonEventStatusEnum): Promise<void> {
        await createEvent(prepareEventRequestData(values, selectorId, status));
        onCreateSuccess?.();
    }

    return (
        <Modal
            centered
            destroyOnClose
            footer={null}
            onCancel={() => setIsOpen(false)}
            open
            title={<Locale stringKey="EVENTS__CREATE__TITLE" />}
            width={modalWidth}
        >
            <EventForm
                closeModal={() => setIsOpen(false)}
                companiesSelector={companiesSelector}
                mode="create"
                onChangeStep={setModalWidth}
                onSubmit={handleSubmit}
            />
        </Modal>
    );
}
